import React from 'react';
import { IonContent, IonPage } from '@ionic/react';

import { StoryList } from '../models/factories/StoryFactory';
import StoryCard from '../components/Catalogue/Story/StoryCard';
import Footer from '../components/Global/Footer/Footer';
import PageHeader from '../components/Global/PageHeader/PageHeader';
import { PageDesctiption } from '../components/Global/PageHeader/pageHeaderStyles';
import { useAppSelector } from '../state/hooks';
import { selectPrefs } from '../state/selectors';
import { shallowEqual } from 'react-redux';
import { useMemo } from 'react';
import {
	filterStoriesByAccessibility,
	sortStoriesByPreferences,
} from '../models/helpers/preferenceRanking';

type StoriesProps = {
	stories: StoryList;
};

const Stories: React.FC<StoriesProps> = ({ stories }) => {
	const userPrefs = useAppSelector(selectPrefs, shallowEqual);

	const prioritisedStories = useMemo(
		() =>
			sortStoriesByPreferences(
				filterStoriesByAccessibility([...stories.stories], userPrefs),
				userPrefs,
			),
		[stories.stories, userPrefs],
	);
	return (
		<IonPage>
			<IonContent fullscreen>
				<main>
					<PageHeader title="Stories" />
					<PageDesctiption>
						{/* TODO: Content Managed Description... */}
						{/* <p>This is the story page description</p>
						<p>This is the story page description</p>
						<p>This is the story page description</p> */}
						{/*<p>*/}
						{/*	Placeholder story page introduction. The North*/}
						{/*	Pennines is a huge hub of culture and activity from*/}
						{/*	x to y. Please enjoy our curated stories featuring*/}
						{/*	exciting places across the pennines.*/}
						{/*</p>*/}
					</PageDesctiption>
					{prioritisedStories.map((story) => {
						return (
							<StoryCard
								key={story.id}
								story={story}
								showDescription={true}
							/>
						);
					})}

					{/* <TopicList topics={topics} /> */}

					<Footer />
				</main>
			</IonContent>
		</IonPage>
	);
};

export default Stories;
